import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../lib/errorHandler';
import { get_all_notifications } from '../../Redux/Actions/AuthUser';
import CommonPagination from '../../Component/Common/CommonPagination';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { Box, Divider, Fab, Typography } from '@mui/material';
import Assets from '../../Component/Common/Assets';
import { format, parseISO } from 'date-fns';

const Notification = () => {
    // ============== Hooks ==============
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [notificationData, setNotificationData] = useState({});
    const [page, setPage] = useState(1);

    // ============== Handler ==============
    const handleChangePage = (e, p) => {
        setPage(p);
    };
    const PerPage = 10;

    const formatDate = (dateString) => {
        const date = parseISO(dateString);
        return format(date, "EEEE 'at' h:mm a");
    };

    // ============== Notification API ==============
    const _get_all_notifications = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": page,
            "date": null,
        }
        response = await dispatch(get_all_notifications(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setNotificationData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    useEffect(() => {
        _get_all_notifications();
    }, [page])
    return (
        <Box padding={"25px"} display={"flex"} flexDirection={"column"} gap={2} >
            <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Notifications</Typography>
            {notificationData?.response?.map((ele) => {
                return (
                    <>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"start"} gap={5}>
                            <Box display={"flex"} gap={2} alignItems={"start"} >
                                <Fab sx={{ boxShadow: "none", backgroundColor: "#F5F9FB", height: "48px", width: "48px" }}>
                                    <Assets absolutePath={true} src={`/assets/img/Notification.svg`} />
                                </Fab>
                                <Box>
                                    <Typography color={"#1A1F36"} fontSize={'14px'} fontFamily={"Satoshi-Medium"}>{ele?.subTitle}</Typography>
                                    <Box maxHeight={"50px"} overflow={"auto"}
                                        sx={{
                                            textAlign: "left",
                                            paddingLeft: "10px",
                                            marginTop: "10px",
                                            direction: "rtl",
                                            "& > *": { direction: "ltr" }
                                        }}
                                    >
                                        <Typography color={"#1A1F36"} fontSize={'14px'} fontFamily={"Satoshi-Medium"}>
                                            {ele?.description}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Typography color={"#A5ACB8"} fontSize={'12px'} whiteSpace={'nowrap'} fontFamily={"Satoshi-Light"}>
                                {ele?.dateAndTime ? formatDate(ele?.dateAndTime) : ""}
                            </Typography>
                        </Box>
                        <Divider />
                    </>
                )
            })}
            <CommonPagination
                totalCount={notificationData?.count}
                count={Math.ceil(notificationData?.count / PerPage)}
                itemsPerPage={PerPage}
                page={page}
                onChange={handleChangePage}
            />
        </Box>
    )
}

export default Notification